import { style } from '@vanilla-extract/css';

export const multiSelectComboboxWrapper = style({
  selectors: {
    '&:is(&)': {
      height: 'fit-content',
    },
  },
});
